import { message } from 'antd';
import * as dashboardService from '../../../../../services/Dashboard';
import * as onboardingService  from '../../../../../services/Onboarding';
import { pushLog2DV2LogServer } from '../../../../../services/logging';
import { OnboardingNewUiUxReduxActions } from "../onboardingNewUiUx.action";
import { validateStringOnly } from '../../../../util/inputValidators';

export const basicInformationReduxAction = {
    UPDATE_BASIC_INFO_STATE_DATA: 'UPDATE_BASIC_INFO_STATE_DATA',
    RESET_STATE_DATA: 'RESET_STATE_DATA',
    API_REQUEST_SUCCESS: 'API_REQUEST_SUCCESS',
    API_REQUEST_FAIL: 'API_REQUEST_FAIL'
}

export const DeveloperReferralOptionsV2 = [
    'LinkedIn Jobs',
    'Email',
    'Google Search',
    'Referrals',
    'Social Media',
    'Ads (Facebook, YouTube, etc)',
    'Others'
];

export const updateParent = (values) => dispatch => {
    dispatch({
        type: OnboardingNewUiUxReduxActions.UPDATE_SECTION_VALUES,
        payload: {
            page: 'basic_profile_page',
            values
        }
    })
};

export const SAVE_ONBOARDING_DATA = (field, state_data) => async (dispatch) => {
    try {
        dispatch(updateParent(state_data));
        const data = await getAPIData(field, state_data)
        if (data && data.action) {
            const response = await dashboardService.updateBasicInfo(data);
            if (!response.data.success) {
                const log_error = {
                  message: `Error Response code from SAVE_ONBOARDING_DATA action ${response.status}`
                };
                dispatch({ type: basicInformationReduxAction.API_REQUEST_FAIL });
                pushLog2DV2LogServer.warn('ONBOARDING', 'SAVE_ONBOARDING_DATA', {}, {}, log_error);
            } else {
                dispatch({ type: basicInformationReduxAction.API_REQUEST_SUCCESS });
                pushLog2DV2LogServer.info('ONBOARDING', 'SAVE_ONBOARDING_DATA', {}, data, null);
            }
        } else if (data.callback && typeof data.callback === 'function') {
            data.callback();
        }
    } catch(e) {
        pushLog2DV2LogServer.warn('ONBOARDING', 'SAVE_ONBOARDING_DATA', {}, {}, e);
    }
}

const getAPIData = async (field, state_data={}) => {
    const { firstName, ref_other_value, lastName, country_id, city_of_residence, phoneNumber, phoneCountry, ref_checked_values, expected_salary, salary_local_currency, removing_referral } = state_data;
    switch(field) {
        case 'firstName':
        case 'lastName':
            if(firstName && lastName && validateStringOnly(firstName) && validateStringOnly(lastName)) {
                return { action: 'UPDATE_NAME_DATA', full_name: `${firstName} ${lastName}`, first_name: firstName, last_name: lastName }
            }
            break;
        case 'country_id':
            if (country_id) {
                return { action: 'UPDATE_COUNTRY_DATA',  country_citizenship_id: null, country_id, city_of_residence };
            }
            break;
        case 'city_of_residence':
            let data = { action: 'UPDATE_COUNTRY_DATA', country_id, country_citizenship_id: null }
            if (city_of_residence) return { ...data, city_of_residence };
            break;
        case 'phoneNumber':
            const isPhoneNumberValid = phoneNumber && typeof phoneNumber === 'string' && phoneNumber.length >= 6 && phoneNumber.length < 20;
            const isCountryCodeValid = phoneCountry && typeof phoneCountry === 'string' && phoneCountry.length <= 4
            if (isPhoneNumberValid && isCountryCodeValid) {
                return { action: 'UPDATE_MOBILE_DATA', phone_number: phoneNumber, phone_country_code: phoneCountry.toLowerCase() };
            }
            break;
        case 'ref_checked_values':
        case 'ref_other_value':
            if (ref_checked_values && ref_checked_values.length > 0) {
                if (!ref_other_value && ref_checked_values.indexOf(DeveloperReferralOptionsV2[DeveloperReferralOptionsV2.length - 1]) >= 0) {
                    return { action: null }
                }
                const data = ref_checked_values.map((ref_checked_value)=>{
                    if (ref_checked_value.toLowerCase() === 'others') {
                        return {
                            ref_checked_values: ref_checked_value,
                            ref_other_value
                        }
                    }
                    return {
                        ref_checked_values: ref_checked_value,
                        ref_other_value: null
                    }
                });
                return { action: null, callback: UPDATE_DEVELOPER_REFERRAL_SOURCE(data) };
            } else if (removing_referral) {
                return { action: null, callback: UPDATE_DEVELOPER_REFERRAL_SOURCE(null) };
            }
            break;
        case 'expected_salary':
            if (expected_salary) {
                return { action: 'UPDATE_EXPECTED_SALARY', expected_salary: expected_salary, salary_local_currency, updateSalaryType: null }
            }
            break;
        default:
            return null
    }
}

const UPDATE_DEVELOPER_REFERRAL_SOURCE = async (data) => {
    try {
      const response = await dashboardService.updateDeveloperReferralSource(data);
      if (response.data.success) {
        pushLog2DV2LogServer.info('ONBOARDING', 'UPDATE_DEVELOPER_REFERRAL_SOURCE', {}, data, null);
      } else {
        message.warn('Error: unable to update referral source');
        const log_error = {
          message: 'Response code from UPDATE_DEVELOPER_REFERRAL_SOURCE is ' + response.status + '.'
        };
        pushLog2DV2LogServer.warn('ONBOARDING', 'UPDATE_DEVELOPER_REFERRAL_SOURCE', {}, {}, log_error);
      }
    } catch (e) {
      message.error('Error: unable to update referral source');
      pushLog2DV2LogServer.error('ONBOARDING', 'UPDATE_DEVELOPER_REFERRAL_SOURCE', {}, {}, e);
    }
};

/**
 * Validates a single field.
 * @param {string} field - The field to validate.
 * @param {*} val - The value of the field.
 * @returns {string[]|null} An array of error messages, or null if no errors.
 */
const validateField = (field, val) => {
    let errors = [];
    switch (field) {
        case 'firstName':
        case 'lastName':
            let fieldName = 'First Name'
            if (field === 'lastName') fieldName = 'Last Name'
            if (!val || val === '') {
                errors.push(`${fieldName} is a required field, it can\'t be empty`);
            } 
            if (val && val.length > 49) {
                errors.push(`${fieldName} can't be greater than 49 characters`);
            }
            const isValidString = validateStringOnly(val);
            if (!isValidString) {
                errors.push(`Only Alphanumeric character is allowed`);
            }
            break;
        case 'phoneNumber':
            if (!val || val === '') {
                errors.push('Please provide your Phone number');
            } else {
                const isPhoneNumberValid = val && typeof val === 'string' && val.length >= 6 && val.length < 20;
                if (!isPhoneNumberValid) {
                    errors.push('Enter a valid phone number between 6 to 20 digits');
                }
            }
            break;
        case 'city_of_residence':
            if (val && val !== '') {
                const isValidString = validateStringOnly(val);
                if (!isValidString) {
                    errors.push('Only Alphanumeric character is allowed');
                }
                if (isValidString && val.length > 100) {
                    errors.push('Maximum character length is 100')
                }
            }
            break;
        case 'expected_salary':
            if (val && val !== '') {
                const salary = parseInt(val, 10)
                const validSalary = salary > 0 && salary <= 99999999999;
                if (!validSalary) {
                    errors.push('Please provide a valid Salary (Max: 99999999999)');
                }
            }
            break;
        case 'country_id':
            if (!val || val === '') {
                errors.push('Please provide your Country')
            }
            break;
        case 'ref_other_value':
            if (!val || val === '') {
                errors.push('Please specify other referral source');
            }
            if (val && !validateStringOnly(val)) {
                errors.push('Only Alphanumeric character is allowed');
            }

            if (val && validateStringOnly(val) && val.length > 255
            ) {
                errors.push('Maximum character length is 255');
            }
            break;
        default:
            break;
    }
    return errors.length ? errors : null;
};

/**
 * Validates the basic information page data.
 * @param {Function} dispatch - The Redux dispatch function.
 * @param {Function} getState - The Redux getState function.
 */
export const VALIDATE_BASIC_INFO_PAGE_DATA = (dispatch, getState) => {
    const state = getState();
    const { basic_profile_page } = state.onboarding_new_ui;
    const { values, hasErrors } = basic_profile_page;
    
    const newErrorObject = { ...hasErrors };

    for (const [field, value] of Object.entries(values)) {
        let errors = null;
        if (field === 'ref_other_value') {
            const isOthersSelected = (values.ref_checked_values || []).indexOf(DeveloperReferralOptionsV2[DeveloperReferralOptionsV2.length - 1]) >= 0;
            if (isOthersSelected) {
                errors = validateField(field, value)
            }
        } else {
            errors = validateField(field, value);
        }
        if (errors) {
            newErrorObject[field] = errors;
        } else {
            delete newErrorObject[field];
        }
    }

    dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA, payload: { page: 'basic_profile_page', errors: newErrorObject }});
};


/**
 * Resets the error state of a field.
 * @param {string} field - The field to reset.
 * @param {*} val - The value of the field.
 * @returns {Function} Redux thunk function.
 */
export const RESET_ERROR_FIELD_STATE = (field, val) => (dispatch, getState) => {
    const state = getState();
    const { basic_profile_page } = state.onboarding_new_ui;
    const { values, hasErrors } = basic_profile_page
    const newErrorObject = { ...hasErrors };
    let errors = null;

    if (field === 'ref_other_value') {
        const isOthersSelected = (values.ref_checked_values || []).indexOf(DeveloperReferralOptionsV2[DeveloperReferralOptionsV2.length - 1]) >= 0;
        if (isOthersSelected) {
            errors = validateField(field, val)
        }
    } else {
        errors = validateField(field, val);
    }

    if (errors) {
        newErrorObject[field] = errors;
    } else {
        delete newErrorObject[field];
    }

    dispatch({ type: OnboardingNewUiUxReduxActions.UPDATE_ERROR_DATA, payload: { page: 'basic_profile_page', errors: newErrorObject } });
};


  export const BasicProfileApiActions = {
    SAVE_ONBOARDING_DATA,
    UPDATE_DEVELOPER_REFERRAL_SOURCE,
    updateParent
  }
